"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceUnit = void 0;
/**
 * Units of Measure to be used with {@link MilStdAttributes#DistanceUnits}
 * Default is meters.
 */
class DistanceUnit {
    static FEET_PER_METER = 3.28084;
    static FLIGHT_LEVEL_PER_METER = 0.0328084; // hundreds of feet
    conversionFactor = 0;
    label;
    constructor(conversionFactor, label) {
        this.conversionFactor = conversionFactor;
        this.label = label;
    }
    static parse(distanceUnitText) {
        if (distanceUnitText == null) {
            return null;
        }
        let parts = distanceUnitText.split(",");
        if (parts.length !== 2) {
            return null;
        }
        let conversionFactor = parseFloat(parts[0].trim());
        let label = parts[1].trim();
        return new DistanceUnit(conversionFactor, label);
    }
    toAttribute() {
        return this.conversionFactor + "," + this.label;
    }
    static METERS = new DistanceUnit(1, "M");
    static FEET = new DistanceUnit(DistanceUnit.FEET_PER_METER, "FT");
    static FLIGHT_LEVEL = new DistanceUnit(DistanceUnit.FLIGHT_LEVEL_PER_METER, "FL");
}
exports.DistanceUnit = DistanceUnit;
//# sourceMappingURL=DistanceUnit.js.map